import {RatingsErrorsFactory} from '../Errors/factory.js'
import {StatusTradeRatingsValueObject} from './StatusTradeRatingsValueObject.js'
import {TokenRequestRatingsValueObject} from './TokenRequestRatingsValueObject.js'

export class RatingsValueObjectsFactory {
  static tokenRequestRatingsValueObject = ({token}) => {
    TokenRequestRatingsValueObject.validate({
      token,
      emptyTokenRatingsError: RatingsErrorsFactory.emptyTokenRatingsError
    })
    return new TokenRequestRatingsValueObject({
      token
    })
  }

  static statusTradeRatingsValueObject = ({status}) => new StatusTradeRatingsValueObject({status})
}
